import { Box } from '@material-ui/core';
import { BorrowerOnboardingDetails, CashInCashOutMethod } from '@nemuru-eng/js-api-client';

import { ValidationDeclaredDataMap } from '@/components/modules/DocumentsValidation/maps/validationDeclaredData.map';
import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';

interface BankAccountDeclaredDataProps {
  borrowerOnboardingDetails: BorrowerOnboardingDetails;
  cashInCashOutMethod: CashInCashOutMethod;
}

export const BankAccountDeclaredData = ({
  borrowerOnboardingDetails,
  cashInCashOutMethod,
}: BankAccountDeclaredDataProps) => {
  const { firstName, lastName, iban } = ValidationDeclaredDataMap.toAccountData(
    borrowerOnboardingDetails,
    cashInCashOutMethod,
  );

  if (!firstName || !lastName || !iban) {
    throw new Error('Not able to find necessary userDetails.documentId data to validate bank account');
  }

  const fieldVariant = FieldVariant.dataRow;

  return (
    <Box display={'flex'} flexDirection={'column'} gridGap={4} width="100%">
      <TextFormField name={'firstName'} label={'FIRST_NAME'} value={firstName} fieldVariant={fieldVariant} disabled />
      <TextFormField name={'lastName'} label={'LAST_NAME'} value={lastName} fieldVariant={fieldVariant} disabled />
      <TextFormField name={'iban'} label={'IBAN'} value={iban} fieldVariant={fieldVariant} disabled />
    </Box>
  );
};
